<template>
  <div class="panel-container">
    <div class="header-container">
      <div class="title-container">
        <span class="title-text">数据完整性</span>
      </div>
    </div>
    <div class="divider-line"></div>
    <div class="main-container">
      <div class="info-item-container" v-for="item in infoList" :key="item.title">
        <div class="right-info-wrapper">
          <div class="title-row">
            <span class="title-text">{{ item.title }}</span>
            <el-tooltip :content="item.tip" placement="top" :hide-after="0" v-if="item.tip">
              <img :src="alertCircleIcon" alt="" class="tip-icon" />
            </el-tooltip>
          </div>
          <div>
            <span class="value-text" :class="{ 'value-warn': item.warn }">{{ item.value }}</span>
            <span class="unit-text">{{ item.unit }}</span>
          </div>
        </div>
      </div>

      <div class="info-item-container bottom-tip-item" v-if="!summary.rowCount">
        <div class="right-info-wrapper">
          <div class="title-row">
            <span class="warn-text">所选区间暂无现货结算数据</span>
          </div>
        </div>
      </div>
      <div class="info-item-container bottom-tip-item" v-else-if="summary.incompleteRtCount > 0">
        <div class="right-info-wrapper">
          <div class="title-row">
            <span class="warn-text">
              有 {{ summary.incompleteRtCount }} 个时段缺实时价，合计收益偏小
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import alertCircleIcon from '@/assets/icons/svg/alert-circle.svg'

defineOptions({ name: 'SpotQualityPanel' })

const props = defineProps({
  summary: {
    type: Object,
    default: () => ({}),
  },
})

function pct(value) {
  if (value === null || value === undefined) return '--'
  return (Number(value) * 100).toFixed(1)
}

const infoList = computed(() => {
  const s = props.summary || {}
  return [
    {
      title: '实时价覆盖率',
      value: pct(s.rtCoverage),
      unit: '%',
      tip: '区间内有实时价的 15 分钟格子占比。低于 100% 说明部分时段缺价，实时收益汇总值偏小',
      warn: s.rtCoverage !== null && s.rtCoverage !== undefined && s.rtCoverage < 1,
    },
    {
      title: '日前价覆盖率',
      value: pct(s.daCoverage),
      unit: '%',
      tip: '区间内有日前价的 15 分钟格子占比',
      warn: s.daCoverage !== null && s.daCoverage !== undefined && s.daCoverage < 1,
    },
    {
      title: '不完整时段',
      value: s.incompleteRtCount ?? '--',
      unit: '个',
      tip: '桶内存在缺价格子的时段数量',
      warn: (s.incompleteRtCount ?? 0) > 0,
    },
    {
      title: '参与汇总电表',
      value: s.meterCount ?? '--',
      unit: '块',
      tip: '参与本次汇总的并网表数量',
    },
  ]
})
</script>

<style lang="scss" scoped>
.panel-container {
  --header-height: 50px;

  & {
    width: 100%;
    height: 100%;
    background: transparent;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }

  .header-container {
    width: 100%;
    height: var(--header-height);
    min-height: var(--header-height);
    display: flex;
    align-items: center;

    .title-text {
      color: #2e2e2e;
      font-family: 'HarmonyOS Sans SC';
      font-size: 16px;
    }
  }

  .divider-line {
    width: 100%;
    height: 1px;
    background: #f0f0f0;
    margin-bottom: 12px;
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
  }

  .info-item-container {
    .right-info-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .title-row {
      display: flex;
      align-items: center;
      gap: 4px;

      .title-text {
        color: #999;
        font-family: 'HarmonyOS Sans SC';
        font-size: 12px;
      }
    }

    .tip-icon {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }

    .value-text {
      color: #2e2e2e;
      font-family: 'HarmonyOS Sans SC';
      font-size: 20px;
      font-weight: 500;

      &.value-warn {
        color: #e6a23c;
      }
    }

    .unit-text {
      color: #999;
      font-family: 'HarmonyOS Sans SC';
      font-size: 12px;
      margin-left: 4px;
    }
  }

  .bottom-tip-item {
    margin-top: auto;

    .warn-text {
      color: #e6a23c;
      font-family: 'HarmonyOS Sans SC';
      font-size: 12px;
      line-height: 1.5;
    }
  }
}
</style>
